const Login = _ => import(/* webpackChunkName: "js/split/Login", webpackPreload: true */ '@/components/views/layout/Login');
export default {
    path: '/login',
    component: Login,
    meta:{
      auth: false,
    },
    beforeEnter: (to, from, next) => {
        if( sessionStorage.getItem('sipac_token') ){
            next('/');
        } else {
            next();
        }
    }
}
